import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import { ProgressBar } from 'primereact/progressbar';
import { Form, Field } from 'react-final-form';
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import axios from "axios";

const PurchaseorderSupplierFormComponent = (props) => {

  const { t } = props;
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [partners, setPartners] = useState([]);
  const purchaseOrderId = props.purchaseOrderId;
  const isOrdered = !!formData.ordered;
  const purchaseOrderSupplierId = window.App.urlVars().purchaseorderSupplierId || null;
  const isUpdate = !!purchaseOrderSupplierId;
  const [currencies, setCurrencies] = useState([]);

  const validate = (data) => {
    const errors = {};
    if (!data.partner && !formData.partner) {
      errors.partner = 'Kötelező mező';
    }
    return errors;
  };

  const apiCall = (method, url, data) => {
    return axios({
      method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    });
  };

  const onSubmit = (data) => {
    setLoading(true);
    const payload = {
      partner: newFormData.partner ?? data.partner ?? formData.partner,
      purchase_order: purchaseOrderId ?? formData.purchase_order,
      currency: newFormData.currency ?? formData.currency,
    };
    const isUpdate = !!(window.App.urlVars().purchaseorderSupplierId || null);
    if (isUpdate) {
      apiCall('patch', '/api/v2/purchase-order-supplier/' + (window.App.urlVars().purchaseorderSupplierId || null), newFormData)
        .then(() => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({ rerenderPurchaseorderSupplierList: Math.random() });
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => setLoading(false));
    } else {
      apiCall('post', '/api/v2/purchase-order-supplier', payload)
        .then(response => {
          const saved = response.data.data;
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({ rerenderPurchaseorderSupplierList: Math.random() });
          const poId = purchaseOrderId ?? formData.purchase_order ?? saved.purchase_order;
          if (props.goback === true) {
            history.push(props.backlink || ('/procurement/purchase-order/read/' + poId));
          } else {
            history.push(
              '/procurement/purchase-order/read/' +
              poId +
              '?update=purchaseorder-supplier&purchaseorderSupplierId=' +
              saved.id
            );
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => setLoading(false));
    }
  };

  const handleMarkOrdered = () => {
    if (!purchaseOrderSupplierId) return;
    setLoading(true);
    apiCall('post', `/api/v2/purchase-order-supplier/${purchaseOrderSupplierId}/ordered`)
      .then(response => {
        window.App.toastShow('success', 'Megrendelés feladva!');
        setFormData({ ...formData, ordered: true });
        window.App.setState({ 
            rerenderPurchaseorderSupplierList: Math.random(),
            rerenderPurchaseorderSupplierForm: Math.random() 
        });
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => setLoading(false));
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  
  useEffect(() => {
    apiCall('get', '/api/v2/partner?item_per_page=9999&search[vendor_material][operator]==&search[vendor_material][value]=true')
      .then(res => {
        setPartners(res.data?.data?.items || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
    apiCall('GET', '/api/v2/dictionary/currency')
      .then(response => {
        setCurrencies(response.data.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if (window.App.urlVars().purchaseorderSupplierId || null) {
      setLoading(true);
      apiCall('get', '/api/v2/purchase-order-supplier/' + (window.App.urlVars().purchaseorderSupplierId || null))
        .then(response => {
          setFormData(response.data.data || {});
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => setLoading(false));
    }
  }, [window.App.urlVars().purchaseorderSupplierId || null, window.App.state?.rerenderPurchaseorderSupplierForm]);

  return (
    <div className={"purchaseorder-supplier-form widget"}>
      {loading && (
        <ProgressBar
          mode="indeterminate"
          style={{ height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0 }}
        />
      )}
      <Form
        onSubmit={onSubmit}
        initialValues={formData}
        validate={validate}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit} className="">
            <div className="p-grid">
              <div className="p-col-12">
                {isOrdered ? (
                  <div className="p-field p-fluid">
                    <label htmlFor="partner">{props.t('fieldSupplier')}</label>
                    <div className="p-mt-2 p-text-bold">
                      {formData?.partner?.name
                        || partners.find(p => p.id === formData.partner)?.name
                        || '-'}
                    </div>
                  </div>
                ) : (
                  <>
                  <div className="p-grid">
                    <div className={"p-col-12 p-lg-8"}>
                      <Field
                        name="partner"
                        render={({ input, meta }) => (
                          <div className="p-field p-fluid">
                            <label
                              htmlFor="partner"
                              className={classNames({ 'p-error': isFormFieldValid(meta) })}
                            >{props.t('fieldSupplier')}</label>
                            <span className="p-d-block">
                              <Dropdown
                                {...input}
                                id="partner"
                                value={formData.partner?.id || formData.partner || input.value}
                                options={window.App.sortDropdownOptions(partners, "name")}
                                optionLabel="name"
                                optionValue="id"
                                filter
                                placeholder={t('selectSupplierPlaceholder')}className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                                onChange={(e) => {
                                  input.onChange(e.value);
                                  setFormData({
                                    ...formData,
                                    partner: e.value,
                                  });
                                  setNewFormData({
                                    ...newFormData,
                                    partner: e.value,
                                  });
                                }}
                              />
                            </span>
                            {getFormErrorMessage(meta)}
                          </div>
                        )}
                      />
                    </div>
                    <div className={"p-col-12 p-lg-4"}>
                      <Field name="currency" render={({input, meta}) => (
                        <div className="p-field p-fluid">
                          <label htmlFor="currency"
                                  className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCurrency')}</label>
                          <span className={"p-d-block"}>
                                      <Dropdown 
                                                onChange={(e) => {
                                                  setFormData({
                                                    ...formData,
                                                    currency: e.value
                                                  })
                                                  setNewFormData({
                                                    ...newFormData,
                                                    currency: e.value
                                                  })
                                                }}
                                                value={formData.currency}
                                                options={window.App.sortDropdownOptions(currencies, "key")}
                                                optionLabel="key"
                                                optionValue="key"
                                                id={"currency"}
                                                emptyMessage={t('noCurrencyYet')}
                                                className={classNames({'p-error': isFormFieldValid(meta)})}
                                      />
                                    </span>
                          {getFormErrorMessage(meta)}
                        </div>
                      )}/>
                    </div>
                  </div>
                  </>
                )}

              </div>
            </div>
            {!isOrdered && (
              <div className="p-grid p-mt-1">
                <div className="p-col-12 p-lg-6" />
                <div className="p-col-12 p-lg-6 p-text-right p-col-align-center">
                  {isUpdate && window.App.state.hasSupplierItems && (
                    <Button
                      type="button"
                      label="Megrendelés feladva"
                      icon="pi pi-lock"
                      className="p-button-warning p-mr-2"
                      loading={loading}
                      onClick={handleMarkOrdered}
                    />
                  )}

                  <Button
                    type="submit"
                    label={t('save')}
                    loading={loading}
                    icon={"pi pi-save"}
                    className="p-button-success"
                  />
                </div>
              </div>
            )}
          </form>
        )}
      />
    </div>
  );

};

export default withTranslation('common')(PurchaseorderSupplierFormComponent);
